import React from "react";
import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { ConfirmModalProps } from "../../types/modal";
import { COMMON_STRINGS } from "../../constants/strings";

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  title,
  description,
  onClose,
  onConfirm,
  confirmText,
  cancelText,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "18px",
            p: 2.5,
            width: "100%",
            maxWidth: "420px",
            background: "#fff",
            boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
          },
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        {/* 🔥 HEADER */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1.5,
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              color: "#0f172a",
            }}
          >
            {title}
          </Typography>

          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* 🔥 BODY */}
        <Box
          sx={{
            mb: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >
          {typeof description === "string" ? (
            <Typography
              sx={{
                fontSize: "13px",
                color: "#64748b",
              }}
            >
              {description}
            </Typography>
          ) : (
            description
          )}
        </Box>

        {/* 🔥 ACTIONS */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            mt: 1,
          }}
        >
          <Button
            onClick={onClose}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              px: 2,
              color: "#64748b",
              "&:hover": {
                background: "#f1f5f9",
              },
            }}
          >
            {cancelText || COMMON_STRINGS.BTN_CANCEL}
          </Button>

          <Button
            onClick={onConfirm}
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              px: 2.5,
              background: "var(--primary)",
              boxShadow: "0 4px 14px rgba(99,102,241,0.3)",
              "&:hover": {
                background: "var(--primary)",
                boxShadow: "0 6px 18px rgba(99,102,241,0.4)",
              },
            }}
          >
            {confirmText || COMMON_STRINGS.BTN_CONFIRM}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmModal;